module.exports = __webpack_public_path__ + "static/img/pillowcase2.3a7da8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pillowcase2.jpg
// module id = 219
// module chunks = 1